var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4958_16182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.8333C11.3807 13.8333 12.5 12.714 12.5 11.3333C12.5 9.95254 11.3807 8.83325 10 8.83325C8.61929 8.83325 7.5 9.95254 7.5 11.3333C7.5 12.714 8.61929 13.8333 10 13.8333Z",
    stroke: "#2A2B28",
    strokeWidth: 1.73077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.66659V15.4999C17.5 15.9419 17.3244 16.3659 17.0118 16.6784C16.6993 16.991 16.2754 17.1666 15.8333 17.1666H4.16667C3.72464 17.1666 3.30072 16.991 2.98816 16.6784C2.67559 16.3659 2.5 15.9419 2.5 15.4999V7.99992C2.5 7.55789 2.67559 7.13397 2.98816 6.82141C3.30072 6.50885 3.72464 6.33325 4.16667 6.33325M4.16667 6.33325H5.83333C6.27536 6.33325 6.69928 6.15766 7.01184 5.8451C7.32441 5.53254 7.5 5.10861 7.5 4.66659C7.5 4.44557 7.5878 4.23361 7.74408 4.07733C7.90036 3.92105 8.11232 3.83325 8.33333 3.83325H10L4.16667 6.33325Z",
    stroke: "#2A2B28",
    strokeWidth: 1.73077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5H17.5",
    stroke: "#2A2B28",
    strokeWidth: 1.73077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3V8",
    stroke: "#2A2B28",
    strokeWidth: 1.73077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4958_16182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPlus);
export default __webpack_public_path__ + "static/media/camera-plus.a2421ea63e91a6de4d94a764cf0d164d.svg";
export { ForwardRef as ReactComponent };